import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

import { MessageEntity } from './chatApi';
import { RootState } from './store';

export interface MessageState {
  [keyof: string]: MessageEntity[];
}

const initialState: MessageState = {};

export const messageSlice = createSlice({
  name: 'messages',
  initialState,
  reducers: {
    setMessage: (state, action: PayloadAction<MessageEntity>) => {
      const { conversationId, id } = action.payload;
      if (!state[conversationId]) {
        state[conversationId] = [];
      }
      // Upsert by id: an optimistic message and the server's canonical copy
      // share an id, so replace in place rather than appending a duplicate.
      const existing = state[conversationId].findIndex((m) => m.id === id);
      if (existing >= 0) {
        state[conversationId][existing] = action.payload;
      } else {
        state[conversationId].push(action.payload);
      }
    },
    setMessages: (
      state,
      action: PayloadAction<{
        conversationId: string;
        messages: MessageEntity[];
      }>
    ) => {
      state[action.payload.conversationId] = action.payload.messages;
    },
    clearConversation: (state, action: PayloadAction<string>) => {
      delete state[action.payload];
    },
  },
});

export const { setMessage, setMessages, clearConversation } =
  messageSlice.actions;

export const selectMessages = (id: string) => (state: RootState) =>
  state.messages[id];

export default messageSlice.reducer;
